import React, { MouseEventHandler, forwardRef, useRef, useState } from "react";
import IconDate from "src/assets/images/iconDate.svg";
import styled from "styled-components";

interface IDatepickerProps {
  defaultValue: any | undefined;
  onClick?: MouseEventHandler<HTMLInputElement>;
}

const Datepicker = forwardRef((props: IDatepickerProps, ref) => {
  // const [value,setValue] = useState
  const inputRef = useRef(null);

  return <DatepickerInput type="text" onClick={props.onClick} value={props.defaultValue} ref={inputRef} readOnly />;
});

const DatepickerInput = styled.input`
  width: 100%;
  height: 28px;
  padding-left: 30px;
  border: none;
  line-height: 28px;
  background: url(${IconDate}) no-repeat left center;
  color: ${({ theme }) => theme.color.secondary};
  font-family: "Poppins";
  font-weight: 400;
  font-size: 16px;
  transform: scale(0.95);
`;

export default Datepicker;
